import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../api';
import './Landing.css';

function Register() {
  const [step, setStep] = useState('register');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [offer, setOffer] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (countdown > 0) {
      const t = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [countdown]);

  const consentsOk = privacy && terms && offer;

  const errText = (detail, fallback) => {
    if (Array.isArray(detail)) return detail.map((e) => e.msg || e.message).join(', ') || fallback;
    if (typeof detail === 'string') return detail;
    return fallback;
  };

  const doRegister = async () => {
    const res = await auth.register({
      name, email, password,
      privacy_policy_accepted: privacy, terms_accepted: terms, offer_accepted: offer,
    });
    localStorage.setItem('token', res.data.access_token);
    navigate('/dashboard');
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    if (!consentsOk) { setError('Чтобы продолжить, примите условия использования сервиса'); return; }
    setLoading(true);
    try {
      await doRegister();
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string' && detail.includes('Email not verified')) {
        try {
          await auth.sendVerificationCode(email);
          setSuccess('Отправили код подтверждения на почту. Введите его, чтобы завершить регистрацию.');
          setCountdown(60);
          setStep('verify');
        } catch (sendErr) {
          setError(errText(sendErr.response?.data?.detail, 'Не удалось отправить код подтверждения'));
        }
      } else {
        setError(errText(detail, 'Не удалось зарегистрироваться'));
      }
    } finally { setLoading(false); }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);
    try {
      const res = await auth.verifyCode(email, code);
      if (res.data.verified) {
        setSuccess('Email подтверждён. Завершаем регистрацию…');
        try { await doRegister(); }
        catch (regErr) { setError(errText(regErr.response?.data?.detail, 'Не удалось завершить регистрацию')); setStep('register'); }
      }
    } catch (err) {
      setError(errText(err.response?.data?.detail, 'Неверный код подтверждения'));
    } finally { setLoading(false); }
  };

  const resend = async () => {
    if (countdown > 0) return;
    setError(''); setSuccess(''); setLoading(true);
    try { await auth.sendVerificationCode(email); setSuccess('Код отправлен повторно'); setCountdown(60); }
    catch (err) { setError(errText(err.response?.data?.detail, 'Не удалось отправить код')); }
    finally { setLoading(false); }
  };

  return (
    <div className="sg">
      <div className="auth">
        <div className="auth-card">
          <Link className="brand" to="/"><img src="/project_logo.png" alt="SkillGate" />SkillGate</Link>

          {step === 'register' ? (
            <>
              <h1>Создайте аккаунт</h1>
              <p className="asub">При регистрации начисляем 500 ₽ бонусом на первые тесты</p>
              {error && <div className="auth-error">{error}</div>}
              {success && <div className="auth-success">{success}</div>}
              <form onSubmit={handleRegister}>
                <div className="field">
                  <label>Название компании</label>
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Например, ООО «ТехноРекрут»" required />
                </div>
                <div className="field">
                  <label>Email</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.ru" required />
                </div>
                <div className="field">
                  <label>Пароль</label>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Минимум 6 символов" minLength="6" required />
                </div>
                <div className="auth-checks">
                  <label className="auth-check"><input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} />Принимаю <Link to="/privacy-policy" target="_blank">Политику обработки данных</Link></label>
                  <label className="auth-check"><input type="checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)} />Принимаю <Link to="/terms-of-service" target="_blank">Пользовательское соглашение</Link></label>
                  <label className="auth-check"><input type="checkbox" checked={offer} onChange={(e) => setOffer(e.target.checked)} />Принимаю условия <Link to="/public-offer" target="_blank">Публичной оферты</Link></label>
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading || !consentsOk}>{loading ? 'Регистрируем…' : 'Зарегистрироваться'}</button>
              </form>
              <p className="auth-foot">Уже есть аккаунт? <Link to="/login">Войти</Link></p>
            </>
          ) : (
            <>
              <h1>Подтвердите email</h1>
              <p className="asub">Мы отправили 6-значный код на {email}</p>
              {error && <div className="auth-error">{error}</div>}
              {success && <div className="auth-success">{success}</div>}
              <div className="auth-hint">Письмо может попасть в «Спам» или «Промоакции». Если код не пришёл за пару минут — загляните туда.</div>
              <form onSubmit={handleVerify}>
                <div className="field">
                  <label>Код подтверждения</label>
                  <input type="text" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="000000" maxLength="6" inputMode="numeric" style={{ textAlign: 'center', fontSize: 24, letterSpacing: '0.4em', fontFamily: 'var(--display)' }} required />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading || code.length !== 6}>{loading ? 'Проверяем…' : 'Подтвердить и войти'}</button>
              </form>
              <p className="auth-foot">
                <button type="button" className="auth-textbtn" onClick={resend} disabled={countdown > 0} style={{ color: countdown > 0 ? 'var(--ink-400)' : 'var(--blue-600)' }}>
                  {countdown > 0 ? `Отправить код повторно (${countdown} с)` : 'Отправить код повторно'}
                </button>
              </p>
              <p className="auth-foot" style={{ marginTop: 4 }}>
                <button type="button" className="auth-textbtn" style={{ color: 'var(--ink-500)' }} onClick={() => { setStep('register'); setCode(''); setError(''); setSuccess(''); }}>Назад к регистрации</button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Register;
